<template>
    <v-app-bar fixed color="primary" hide-on-scroll app  tile flat class="bottom-bordered" scroll-threshold="10">
        <v-app-bar-nav-icon to="/explore/">
            <v-icon large>mdi-chevron-left</v-icon>
        </v-app-bar-nav-icon>
        <v-text-field 
        v-model="searchField"
        :label="searchLabel"
        flat 
        solo 
        outlined 
        color="grey" 
        dense 
        hide-details 
        tile 
        prepend-inner-icon="mdi-magnify" 
        autofocus 
        @input="searchQueryAppend"
        @click:clear="clearSearch"
        clearable></v-text-field>
        <template v-slot:extension>
            <v-tabs color="grey" centered v-model="$store.state.search.searchModel">
                <v-tab v-for="(tab, i) in $store.state.search.searchTabs" :to="`${tab.link}`" 
                :key="'search-tab-'+i"  replace>{{tab.title}}</v-tab>
            </v-tabs>
        </template>
    </v-app-bar>
</template>
<script>
export default {
    data: () => ({
        label: "Search",
        searchKey: '',
        searchTimeout: null,
    }),

    created() {
    },

    computed: {
        searchLabel() {
            if(this.$route.name) return "Search " + this.$route.name
            return "Search"
        },
        searchField: {
            get() {
                return this.$route.query.key ? this.$route.query.key : '' 
            },

            set(val) {
                this.searchKey = val
            }
        }
    },

    methods: {
        searchQueryAppend() {
            if(this.searchTimeout) clearTimeout(this.searchTimeout)

            if(!!this.searchKey && /\S/.test(this.searchKey) && (this.searchKey !== this.$route.query.key)) {
                this.searchTimeout = setTimeout(() => {
                    this.$router.replace(`${this.$route.path}?key=${this.searchKey}`, () => {})
                    this.$router.push(`${this.$route.path}?key=${this.searchKey}`, () => {})
                }, 500)
            }
        },

        clearSearch() {
            this.$router.push(`${this.$route.path}`)
        }
    }
}
</script>